import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getAccountDisclaimer } from "src/utils/account";
import CreditRatingDisclaimer from "./CreditRatingDisclaimer";

function mapStateToProps({ account }: ApplicationStore) {
    return {
        description: getAccountDisclaimer(account)("soft_pull_disclaimer_description")(
            "CreditRatingDisclaimer.description"
        ),
    };
}

export default connect(mapStateToProps)(CreditRatingDisclaimer);
